import { Fragment } from "react";
import { Input, Label } from "reactstrap";
import { LI, P } from "../../../../../../AbstractElements";
import { VariationSwitchesData1 } from "../../../../../../Data/Forms&Table/Forms/FormWidgets";

const SkewedFlipSwitch = () => {
  return (
    <>
      {VariationSwitchesData1.map((data) => (
        <Fragment key={data.id}>
          <LI className="tg-list-item">
            <Input className={`tgl tgl-${data.class}`} id={`cb${data.id}`} type="checkbox" />
            <Label className="tgl-btn text-white" data-tg-off={data.off} data-tg-on={data.on} htmlFor={`cb${data.id}`} />
          </LI>
          <LI>
            <P>{data.text}</P>
          </LI>
        </Fragment>
      ))}
    </>
  );
};
export default SkewedFlipSwitch